import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';

// ========== الأيقونات ==========
const icons = [
  {
    label: 'ملعب كرة سلة 3X3',
    svg: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <path d="M4.93 4.93C6.58 8.58 6.58 15.42 4.93 19.07"/>
        <path d="M19.07 4.93C17.42 8.58 17.42 15.42 19.07 19.07"/>
        <line x1="2" y1="12" x2="22" y2="12"/>
      </svg>
    ),
  },
  {
    label: 'شاطئ خارجي',
    svg: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <path d="M22 8s-2-2-4 0-2 4-4 4"/>
        <path d="M3 21h18"/>
        <circle cx="8" cy="7" r="4"/>
      </svg>
    ),
  },
  {
    label: 'حمام سباحة للأطفال',
    svg: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 12h20"/>
        <path d="M2 16c2-2 4 0 6 0s4-2 6 0 4 0 6 0"/>
        <path d="M2 20c2-2 4 0 6 0s4-2 6 0 4 0 6 0"/>
        <circle cx="12" cy="6" r="2"/>
        <path d="M10 9l2 3 2-3"/>
      </svg>
    ),
  },
  {
    label: 'المدرج',
    svg: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 20h18"/>
        <path d="M3 20L7 14h4l4-6h3"/>
        <path d="M7 14h10"/>
        <path d="M11 8h6"/>
      </svg>
    ),
  },
  {
    label: 'ملعب جولف مع بحيرة',
    svg: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2v10"/>
        <path d="M12 2l5 3-5 3"/>
        <circle cx="12" cy="18" r="1"/>
        <path d="M5 20c0-3 3-5 7-5s7 2 7 5"/>
      </svg>
    ),
  },
  {
    label: 'صالة ألعاب رياضية داخلية',
    svg: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6 5v14M18 5v14"/>
        <path d="M2 8h4M18 8h4M2 16h4M18 16h4"/>
        <line x1="6" y1="12" x2="18" y2="12"/>
      </svg>
    ),
  },
  {
    label: 'منطقة لعب الأطفال',
    svg: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22V12"/>
        <path d="M5 12l7-10 7 10"/>
        <path d="M5 12h14"/>
        <path d="M8 22l4-10 4 10"/>
      </svg>
    ),
  },
  {
    label: 'المرافق الرياضية',
    svg: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <path d="M12 2a14.5 14.5 0 0 0 0 20"/>
        <path d="M2 12h20"/>
      </svg>
    ),
  },
  {
    label: 'حمام السباحة',
    svg: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 12c2-2 4 0 6 0s4-2 6 0 4 0 6 0"/>
        <path d="M2 16c2-2 4 0 6 0s4-2 6 0 4 0 6 0"/>
        <path d="M6 8h.01M10 6h.01"/>
        <path d="M8 4l2 4"/>
      </svg>
    ),
  },
  {
    label: 'ملعب تنس',
    svg: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <path d="M12 2C8 6 8 18 12 22"/>
        <path d="M12 2c4 4 4 16 0 20"/>
        <line x1="2" y1="12" x2="22" y2="12"/>
      </svg>
    ),
  },
  {
    label: 'منطقة جلوس خارجية',
    svg: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 9V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v2"/>
        <path d="M2 11v5a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v2H6v-2a2 2 0 0 0-4 0Z"/>
        <path d="M6 18v3M18 18v3"/>
      </svg>
    ),
  },
  {
    label: 'مسار الركض/المشي',
    svg: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="13" cy="4" r="1"/>
        <path d="M7 21l3-6 2 2 2-3 3 7"/>
        <path d="M9 11l1-3 3 1 2-4"/>
      </svg>
    ),
  },
];

export const EmaarwasaelElraha = () => {
  const sectionRef = useRef(null);
  const headerRef  = useRef(null);
  const iconsRef   = useRef([]);

  // ─── Header animation ────────────────────────────────────────
  useEffect(() => {
    const section = sectionRef.current;
    const header  = headerRef.current;
    if (!section || !header) return;

    gsap.set(header, { opacity: 0, y: 35 });

    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting)
          gsap.to(header, { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' });
        else
          gsap.set(header, { opacity: 0, y: 35 });
      });
    }, { threshold: 0.1 });

    obs.observe(section);
    return () => obs.disconnect();
  }, []);

  // ─── Icons animation ──────────────────────────────────────────
  useEffect(() => {
    const section = sectionRef.current;
    const items   = iconsRef.current.filter(Boolean);
    if (!section || !items.length) return;

    gsap.set(items, { opacity: 0, y: 30, scale: 0.9 });

    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          gsap.to(items, {
            opacity:  1,
            y:        0,
            scale:    1,
            duration: 0.6,
            ease:     'power3.out',
            stagger:  0.07,
          });
        } else {
          gsap.set(items, { opacity: 0, y: 30, scale: 0.9 });
        }
      });
    }, { threshold: 0.1 });

    obs.observe(section);
    return () => obs.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      style={{
        background:  '#fff',
        padding:     '90px 6vw 80px',
        fontFamily:  "'Cairo', sans-serif",
        direction:   'rtl',
        overflow:    'hidden',
      }}
    >
      {/* ── Header ── */}
      <div ref={headerRef} style={{ marginBottom: '64px', opacity: 0 }}>

        {/* Eyebrow */}
        <p style={{
          fontSize:      '12px',
          fontWeight:    '600',
          color:         '#c8a04a',
          letterSpacing: '4px',
          textTransform: 'uppercase',
          margin:        '0 0 14px 0',
        }}>
          EMAAR GOLF FIELD
        </p>

        {/* Title */}
        <h2 style={{
          fontSize:   'clamp(28px, 4vw, 48px)',
          fontWeight: '900',
          color:      '#1a1a1a',
          margin:     '0 0 16px 0',
          lineHeight: '1.2',
        }}>
          وسائل الراحة
        </h2>

        {/* Gold line */}
        <div style={{
          width:        '60px',
          height:       '3px',
          background:   'linear-gradient(to left, #c8a04a, #f0d080)',
          borderRadius: '2px',
          marginBottom: '24px',
        }} />

        {/* Description */}
        <p style={{
          fontSize:   'clamp(14px, 1.6vw, 17px)',
          color:      '#555',
          lineHeight: '1.9',
          maxWidth:   '780px',
          margin:     0,
        }}>
          تقدم مشاريع إعمار أسلوب حياة متكاملاً يجمع بين الفخامة والراحة في أرقى الوجهات السكنية بدبي.
          من المساحات الخضراء الواسعة والممرات المخصصة للمشي، إلى المرافق الرياضية الحديثة
          والمناطق الترفيهية المتنوعة، تم تصميم كل تفصيل بعناية ليمنح السكان تجربة معيشية استثنائية
          تلبي تطلعات الحياة العصرية.{' '}
          <span style={{ color: '#c8a04a' }}>✦</span>
        </p>
      </div>

      {/* ── Icons Grid ── */}
      <div style={{
        display:             'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))',
        gap:                 '32px 20px',
      }}>
        {icons.map((item, i) => (
          <div
            key={i}
            ref={(el) => (iconsRef.current[i] = el)}
            onMouseEnter={(e) => {
              gsap.to(e.currentTarget, { y: -6, duration: 0.25, ease: 'power2.out' });
              gsap.to(e.currentTarget.querySelector('.icon-wrap'), {
                background:   'rgba(200,160,74,0.12)',
                borderColor:  '#c8a04a',
                duration:     0.25,
              });
              gsap.to(e.currentTarget.querySelector('.icon-svg'), {
                color:    '#c8a04a',
                scale:    1.1,
                duration: 0.25,
              });
            }}
            onMouseLeave={(e) => {
              gsap.to(e.currentTarget, { y: 0, duration: 0.25, ease: 'power2.out' });
              gsap.to(e.currentTarget.querySelector('.icon-wrap'), {
                background:  'rgba(200,160,74,0.06)',
                borderColor: 'rgba(200,160,74,0.2)',
                duration:    0.25,
              });
              gsap.to(e.currentTarget.querySelector('.icon-svg'), {
                color:    '#b8903a',
                scale:    1,
                duration: 0.25,
              });
            }}
            style={{
              display:        'flex',
              flexDirection:  'column',
              alignItems:     'center',
              gap:            '12px',
              cursor:         'default',
              opacity:        0,
            }}
          >
            {/* Icon circle */}
            <div
              className="icon-wrap"
              style={{
                width:        '80px',
                height:       '80px',
                borderRadius: '50%',
                background:   'rgba(200,160,74,0.06)',
                border:       '1px solid rgba(200,160,74,0.2)',
                display:      'flex',
                alignItems:   'center',
                justifyContent: 'center',
                transition:   'background 0.25s ease, border-color 0.25s ease',
              }}
            >
              <div
                className="icon-svg"
                style={{ color: '#b8903a', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              >
                {item.svg}
              </div>
            </div>

            {/* Label */}
            <p style={{
              fontSize:   'clamp(12px, 1.4vw, 14px)',
              fontWeight: '600',
              color:      '#333',
              margin:     0,
              textAlign:  'center',
              lineHeight: '1.4',
            }}>
              {item.label}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};